import { createSidecarMedium } from '../../../../../../external/use-sidecar/dist/es2015/medium.js';

var effectCar = createSidecarMedium();

export { effectCar };
